import type { ReactNode } from "react";
import { Icon } from "./Icon";

/** Qidiruv va yangilash — deyarli har bir ro'yxatda bir xil. */
export function Toolbar({
  search,
  onSearch,
  placeholder = "Qidirish…",
  onRefresh,
  refreshing,
  children,
}: {
  search?: string;
  onSearch?: (value: string) => void;
  placeholder?: string;
  onRefresh?: () => void;
  refreshing?: boolean;
  children?: ReactNode;
}) {
  return (
    <div className="toolbar">
      {onSearch && (
        <div className="toolbar-grow search-box">
          <Icon name="search" size={16} className="icon-inside" />
          <input
            className="input"
            placeholder={placeholder}
            value={search ?? ""}
            onChange={(event) => onSearch(event.target.value)}
          />
        </div>
      )}
      {children}
      {onRefresh && (
        <button
          type="button"
          className="btn btn-outlined"
          onClick={onRefresh}
          disabled={refreshing}
        >
          <Icon name="refresh" size={16} />
          Yangilash
        </button>
      )}
    </div>
  );
}

/**
 * Bir nechta qiymatdan bittasini tanlash.
 *
 * Ikki ko'rinish: `segmented` (sukut — filtr panelida kulrang
 * yo'lakdagi tugmalar) va `tabs` (sahifa bo'limlari — tagiga
 * chizilgan yorliqlar). Variant ixtiyoriy: mavjud chaqiruvlar
 * o'zgarmaydi.
 */
export function SegmentedFilter<T extends string>({
  value,
  options,
  onChange,
  variant = "segmented",
}: {
  value: T;
  options: Array<{ value: T; label: string; count?: number }>;
  onChange: (value: T) => void;
  variant?: "segmented" | "tabs";
}) {
  const tabs = variant === "tabs";
  return (
    <div className={tabs ? "tabs" : "segmented"} role={tabs ? "tablist" : "group"}>
      {options.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            className={`${tabs ? "tab" : "segmented-item"}${active ? " active" : ""}`}
            onClick={() => onChange(option.value)}
            role={tabs ? "tab" : undefined}
            aria-selected={tabs ? active : undefined}
            aria-pressed={tabs ? undefined : active}
          >
            {option.label}
            {option.count !== undefined && <span className="tab-count num">{option.count}</span>}
          </button>
        );
      })}
    </div>
  );
}

/** Tagiga chizilgan yorliqlar — `SegmentedFilter variant="tabs"` qisqartmasi. */
export function Tabs<T extends string>(props: {
  value: T;
  options: Array<{ value: T; label: string; count?: number }>;
  onChange: (value: T) => void;
}) {
  return <SegmentedFilter {...props} variant="tabs" />;
}
